<template>
  <span class="mb-2 image-component"><img v-bind:src="content.media"></span>
</template>

<script>
    export default {
        name: "ImageComponent",
        props:{
            content: Object,
            idx: Number,
        },
        data(){
            return {
                response : null
            }
        },
        created() {
            console.log(this.content)
        },
    }
</script>

<style scoped>
img{
  max-height: 35px;
}
</style>